import {Response} from 'notifications';

export interface ErrorState {
  errors: Array<string>;
  errorMessage: string;
}

export function getSpecError(response: Response): ErrorState | null {
  const responseJSON = response.responseJSON;
  if (responseJSON && responseJSON.specError) {
    return {
      errors: responseJSON.errors,
      errorMessage: responseJSON.userMessage,
    };
  }
  return null;
}

export default getSpecError;
